
import { getSeconds } from "./timeUtils";

const VI_BASE_URL = "https://www.videoindexer.ai/embed/player";
const VI_DEFAULT_LOCATION = "eastus"

export const getViCitationSrc = (docId, docsById, blobSasToken = "", viAccessToken = "") => {
    const doc = docsById[docId];
    if (!doc) {
        return "";
    }

    if (doc.type === "video_section") {
        const time = getSeconds(doc.start_time);
        //const url = `${VI_BASE_URL}/${doc.account_id}/${doc.video_id}?locale=en&location=${doc.location}&t=${time}&captions=en-US&showCaptions=true&boundingBoxes=detectedObjects,people`;
        const url = `${VI_BASE_URL}/${doc.account_id}/${doc.video_id}?locale=en&location=${VI_DEFAULT_LOCATION}&t=${time}&captions=en-US&showCaptions=true&boundingBoxes=detectedObjects,people&accessToken=${viAccessToken}`;
        return url;
    }
    else {
        const url = doc.source + '?' + blobSasToken;
        return url;
    }
};

export const getContentType = (docId = "", docsById) => {
    const doc = docsById[docId];
    if (!doc) {
        return "";
    }
    return `${doc.type}`;
};

export const getVideoTitle = (docId = "", docsById, displayStartTime = true, displayEndTime = false) => {
    const doc = docsById[docId];
    if (!doc) {
        return "";
    }
    const startTime = getFormattedStartTime(doc);
    if (displayStartTime && displayEndTime) {
        const endTime = getFormattedEndTime(doc);
        return `${doc.video_name} (${startTime} - ${endTime})`;
    }
    if (displayStartTime) {
        return `${doc.video_name} (${startTime})`;
    }
    return `${doc.video_name}`;
};

export const getDocumentTitle = (docId = "", docsById) => {
    const doc = docsById[docId];
    if (!doc) {
        return "";
    }
    if (doc.page_number && doc.page_number > 0) {
        return `${doc.document_name} (Page ${doc.page_number})`;
    }
    return `${doc.document_name}`;
};

export const getFormattedStartTime = (doc) => {
    if (doc.start_time) {
        return doc.start_time.split(".")[0];
    }
    return "";
};
export const getFormattedEndTime = (doc) => {
    if (doc.end_time) {
        return doc.end_time.split(".")[0];
    }
    return "";
};

export const getPageNumber = (docId = "", docsById) => {
    const doc = docsById[docId];
    if (!doc) {
        return 0;
    }
    return doc.page_number;
};

export const getSearchScore = (docId = "", docsById) => {
    const doc = docsById[docId];
    if (!doc) {
        return 0;
    }
    return doc.search_score;
};
